// Vendors
import { useLayoutEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Event handlers
import { TokenHandlers } from '../handlers/token.handlers';

const useTokenHook = (): void => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const { showBoundary: setError } = useErrorBoundary();

  const { informationFlags, setInformationFlags } = useAppInformationContextConsumerHook();

  const { handleFetchCustomerAuthorizationData } = TokenHandlers({
    informationFlags,
    setInformationFlags,
    setError,
    urlSearchParams,
  });

  useLayoutEffect(() => {
    handleFetchCustomerAuthorizationData();
  }, [informationFlags]);
};

export { useTokenHook };
